import React from 'react';
import { TwitterIcon, LinkedinIcon, FacebookIcon } from 'lucide-react';
const GT_LOGO_URL = 'https://www.gtlaw.com/-/media/images/global-sitewide-images/logo.svg?rev=d07323a607914ace919ae5feec7c119b&hash=59AF347B3177907F6747626218361229';
export const Footer = () => {
  return <footer className="bg-[#1E1D14] text-white border-t border-[#C4A44A]" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-119">
        <div className="grid md:grid-cols-4 gap-12" data-id="element-120">
          <div className="md:col-span-1" data-id="element-121">
            <div className="mb-6" data-id="element-122">
              <img src={GT_LOGO_URL} alt="Greenberg Traurig" className="h-10 brightness-0 invert" data-id="element-123" />
            </div>
            <p className="text-white mb-8 font-light leading-relaxed" data-id="element-124">
              Your trusted advisor in gTLD applications and domain innovation.
            </p>
          </div>
          <div data-id="element-125">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-[#C4A44A]" data-id="element-126">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-127">
              <li data-id="element-128">
                <a href="#about" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-129">
                  About gTLDs
                </a>
              </li>
              <li data-id="element-130">
                <a href="#process" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-131">
                  Application Process
                </a>
              </li>
              <li data-id="element-132">
                <a href="#benefits" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-133">
                  Benefits
                </a>
              </li>
              <li data-id="element-134">
                <a href="#faq" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-135">
                  FAQ
                </a>
              </li>
              <li data-id="element-136">
                <a href="#contact" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-137">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-138">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-[#C4A44A]" data-id="element-139">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-140">
              <li data-id="element-141">
                <a href="https://newgtldprogram.icann.org/en/application-rounds/round2/agb" target="_blank" rel="noopener noreferrer" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-142">
                  gTLD Applicant Guidebook
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-143">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-[#C4A44A]" data-id="element-144">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-145">
              <li data-id="element-146">
                <a href="https://www.gtlaw.com/en/general/footer/privacy-notice" target="_blank" rel="noopener noreferrer" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-147">
                  Privacy Notice
                </a>
              </li>
              <li data-id="element-148">
                <a href="https://www.gtlaw.com/en/general/footer/terms-of-use" target="_blank" rel="noopener noreferrer" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-149">
                  Terms of Use
                </a>
              </li>
              <li data-id="element-150">
                <a href="https://www.gtlaw.com/en/general/footer/cookie-notice" target="_blank" rel="noopener noreferrer" className="text-[#EDE9DB] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-151">
                  Cookie Notice
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#3D3A25] text-center text-[#5A5535] text-sm" data-id="element-152">
          <p data-id="element-153">&copy; {new Date().getFullYear()} Greenberg Traurig, LLP.</p>
          <p className="mt-2" data-id="element-154">Attorney Advertising.</p>
          <p className="mt-2" data-id="element-155">All rights reserved.</p>
        </div>
      </div>
    </footer>;
};